/**
 * Plugwell TurboFlow Pro OS 2.0 Theme JS
 * Built for plugwellshop.com
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Accessibility: Skip to Content Link
  const skipLink = document.querySelector('.skip-to-content-link');
  if (skipLink) {
    skipLink.addEventListener('click', (e) => {
      e.preventDefault();
      const mainContent = document.getElementById('MainContent');
      if (mainContent) {
        mainContent.setAttribute('tabindex', '-1');
        mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
        mainContent.focus({ preventScroll: true });
      }
    });
  }

  // 2. Cart Drawer open/close
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartDrawerOverlay');
  const openButtons = document.querySelectorAll('.open-cart-drawer');
  const closeButtons = document.querySelectorAll('.close-cart-btn');

  function openCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('active');
      cartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('active');
      cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  openButtons.forEach(btn => btn.addEventListener('click', openCart));
  closeButtons.forEach(btn => btn.addEventListener('click', closeCart));
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // 3. Popular & Hot Products Dropdown / Popover
  const hotBtn = document.getElementById('hotProductsBtn');
  const hotPopover = document.getElementById('hotProductsPopover');
  if (hotBtn && hotPopover) {
    const togglePopover = (show) => {
      const isCurrentlyHidden = hotPopover.style.display === 'none' || !hotPopover.style.display;
      const willShow = show !== undefined ? show : isCurrentlyHidden;
      hotPopover.style.display = willShow ? 'block' : 'none';
      hotBtn.setAttribute('aria-expanded', willShow ? 'true' : 'false');
      if (willShow) {
        hotBtn.classList.add('active');
      } else {
        hotBtn.classList.remove('active');
      }
    };

    hotBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePopover();
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!hotPopover.contains(e.target) && !hotBtn.contains(e.target)) {
        togglePopover(false);
      }
    });

    // Close on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        togglePopover(false);
      }
    });

    // Hot products popover filter chips
    const popoverChips = hotPopover.querySelectorAll('.popover-chip');
    const popoverItems = hotPopover.querySelectorAll('.popover-item');
    popoverChips.forEach(chip => {
      chip.addEventListener('click', (e) => {
        e.stopPropagation();
        popoverChips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
        const selectedTab = chip.getAttribute('data-tab');

        popoverItems.forEach(item => {
          const itemCat = item.getAttribute('data-cat') || '';
          if (selectedTab === 'all' || itemCat.includes(selectedTab)) {
            item.style.display = 'flex';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });

    // Popover footer / view links
    const popoverLinks = hotPopover.querySelectorAll('.popover-all-link, .popover-btn');
    popoverLinks.forEach(link => {
      link.addEventListener('click', () => {
        togglePopover(false);
      });
    });
  }

  // 3b. Shop Mega Menu Dropdown Interaction
  const shopNavItem = document.getElementById('shopNavItem');
  const shopNavTrigger = document.getElementById('shopNavTrigger');
  const shopMegaMenu = document.getElementById('shopMegaMenu');
  if (shopNavItem && shopNavTrigger && shopMegaMenu) {
    // Click toggle on mobile/touch screens
    shopNavTrigger.addEventListener('click', (e) => {
      if (window.innerWidth <= 1024 || ('ontouchstart' in window)) {
        e.preventDefault();
        const isOpen = shopNavItem.classList.contains('active');
        if (isOpen) {
          shopNavItem.classList.remove('active');
          shopNavTrigger.setAttribute('aria-expanded', 'false');
        } else {
          shopNavItem.classList.add('active');
          shopNavTrigger.setAttribute('aria-expanded', 'true');
        }
      }
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!shopNavItem.contains(e.target)) {
        shopNavItem.classList.remove('active');
        shopNavTrigger.setAttribute('aria-expanded', 'false');
      }
    });

    // Close on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        shopNavItem.classList.remove('active');
        shopNavTrigger.setAttribute('aria-expanded', 'false');
      }
    });

    const megaLinks = shopMegaMenu.querySelectorAll('a');
    megaLinks.forEach(link => {
      link.addEventListener('click', () => {
        shopNavItem.classList.remove('active');
        shopNavTrigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // 4. Category Tabs and Live Product Grid Filtering (Featured & Collections)
  function activateCategoryTab(tabKey) {
    const tabsContainer = document.getElementById('featured-gear');
    if (!tabsContainer) return;

    // Update tab button visual state
    const tabButtons = tabsContainer.querySelectorAll('.tab-btn');
    tabButtons.forEach(btn => {
      if (btn.getAttribute('data-tab') === tabKey) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Filter product grid items
    const productWrappers = tabsContainer.querySelectorAll('.plugwell-product-wrapper');
    productWrappers.forEach(wrapper => {
      const cat = (wrapper.getAttribute('data-category') || '').toLowerCase();
      const target = (tabKey || '').toLowerCase();
      if (target === 'all' || target === 'featured' || cat.includes(target)) {
        wrapper.style.display = 'block';
      } else {
        wrapper.style.display = 'none';
      }
    });
  }

  // Tab buttons click inside #featured-gear
  const tabButtons = document.querySelectorAll('#featured-gear .tab-btn');
  tabButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const tabKey = btn.getAttribute('data-tab') || 'featured';
      activateCategoryTab(tabKey);
    });
  });

  // Search collection redirect handler
  const searchForm = document.querySelector('.search-form');
  if (searchForm) {
    searchForm.addEventListener('submit', (e) => {
      const colSelect = document.getElementById('HeaderCollectionSelect');
      const searchInput = searchForm.querySelector('.search-input');
      const q = searchInput ? searchInput.value.trim() : '';
      if (colSelect && colSelect.value) {
        e.preventDefault();
        const dest = '/collections/' + colSelect.value + (q ? '?q=' + encodeURIComponent(q) : '');
        window.location.href = dest;
      }
    });
  }

  // 5. Navigation Category Buttons
  const navCatLinks = document.querySelectorAll('.nav-cat-link');
  navCatLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const tabKey = link.getAttribute('data-tab');
      const targetSec = document.getElementById('featured-gear');
      if (targetSec && tabKey) {
        e.preventDefault();
        activateCategoryTab(tabKey);
        targetSec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (hotPopover) {
          hotPopover.style.display = 'none';
          if (hotBtn) {
            hotBtn.setAttribute('aria-expanded', 'false');
            hotBtn.classList.remove('active');
          }
        }
        if (shopNavItem) {
          shopNavItem.classList.remove('active');
          if (shopNavTrigger) shopNavTrigger.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });

  // 6. Anchor Links Smooth Scrolling (#home, #reviews, #faq, etc.)
  const anchorLinks = document.querySelectorAll('.nav-anchor-link, a[href^="#"]');
  anchorLinks.forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const href = anchor.getAttribute('href');
      if (href && href.startsWith('#') && href.length > 1 && !anchor.classList.contains('nav-cat-link')) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (hotPopover) {
            hotPopover.style.display = 'none';
            if (hotBtn) {
              hotBtn.setAttribute('aria-expanded', 'false');
              hotBtn.classList.remove('active');
            }
          }
        }
      }
    });
  });

  // 7. Countdown Clock Tick
  const countdown = document.querySelector('.deal-countdown');
  if (countdown) {
    let hours = parseInt(countdown.getAttribute('data-hours') || '14', 10);
    let minutes = 28;
    let seconds = 45;

    setInterval(() => {
      seconds--;
      if (seconds < 0) {
        seconds = 59;
        minutes--;
        if (minutes < 0) {
          minutes = 59;
          hours--;
          if (hours < 0) hours = 23;
        }
      }
      const hEl = countdown.querySelector('.hours');
      const mEl = countdown.querySelector('.minutes');
      const sEl = countdown.querySelector('.seconds');
      if (hEl) hEl.textContent = String(hours).padStart(2, '0');
      if (mEl) mEl.textContent = String(minutes).padStart(2, '0');
      if (sEl) sEl.textContent = String(seconds).padStart(2, '0');
    }, 1000);
  }

  // 8. Mobile Navigation Drawer Toggle
  const mobileToggle = document.getElementById('mobileMenuToggle');
  const mobileDrawer = document.getElementById('mobileDrawer');
  const mobileOverlay = document.getElementById('mobileDrawerOverlay');
  const mobileClose = document.getElementById('mobileDrawerClose');

  function openMobileDrawer() {
    if (mobileDrawer) mobileDrawer.classList.add('open');
    if (mobileOverlay) mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileDrawer() {
    if (mobileDrawer) mobileDrawer.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileDrawer);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileDrawer);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileDrawer);

  const drawerLinks = document.querySelectorAll('.mobile-drawer a, .mobile-drawer button');
  drawerLinks.forEach(dl => {
    dl.addEventListener('click', () => {
      closeMobileDrawer();
    });
  });

  // 9. Dynamic Hero Product Slider Controller
  const heroSlider = document.getElementById('HeroMainSlider');
  if (heroSlider) {
    const slides = heroSlider.querySelectorAll('.slide');
    const tabs = heroSlider.querySelectorAll('.slider-thumbnails-tabs .tab-chip');
    const prevBtn = document.getElementById('HeroSliderPrev');
    const nextBtn = document.getElementById('HeroSliderNext');
    let currentIndex = 0;
    let autoInterval = null;

    const heroSec = document.querySelector('.plugwell-hero-section');
    const isAutoplay = heroSec ? heroSec.getAttribute('data-autoplay') !== 'false' : true;
    const delaySec = heroSec ? parseInt(heroSec.getAttribute('data-delay') || '5', 10) : 5;

    function goToSlide(index) {
      if (!slides.length) return;
      currentIndex = (index + slides.length) % slides.length;
      slides.forEach((s, idx) => {
        if (idx === currentIndex) {
          s.classList.add('active');
        } else {
          s.classList.remove('active');
        }
      });
      tabs.forEach((t, idx) => {
        if (idx === currentIndex) {
          t.classList.add('active');
        } else {
          t.classList.remove('active');
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        goToSlide(currentIndex - 1);
        resetAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        goToSlide(currentIndex + 1);
        resetAutoplay();
      });
    }

    tabs.forEach((tab, idx) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        goToSlide(idx);
        resetAutoplay();
      });
    });

    function startAutoplay() {
      if (!isAutoplay || slides.length <= 1) return;
      stopAutoplay();
      autoInterval = setInterval(() => {
        goToSlide(currentIndex + 1);
      }, delaySec * 1000);
    }

    function stopAutoplay() {
      if (autoInterval) {
        clearInterval(autoInterval);
        autoInterval = null;
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    heroSlider.addEventListener('mouseenter', stopAutoplay);
    heroSlider.addEventListener('mouseleave', startAutoplay);

    // Touch gesture support on mobile
    let touchX = 0;
    heroSlider.addEventListener('touchstart', (e) => {
      touchX = e.touches[0].clientX;
    }, { passive: true });

    heroSlider.addEventListener('touchend', (e) => {
      const diffX = touchX - e.changedTouches[0].clientX;
      if (diffX > 45) {
        goToSlide(currentIndex + 1);
        resetAutoplay();
      } else if (diffX < -45) {
        goToSlide(currentIndex - 1);
        resetAutoplay();
      }
    }, { passive: true });

    startAutoplay();
  }
});